var map = {
	"./PAP_cat_icon_1-to-1.svg": [
		66945
	],
	"./PAP_cat_icon_1to1-other.svg": [
		40952,
		952
	],
	"./PAP_cat_icon_blog-theme-design.svg": [
		88197,
		8197
	],
	"./PAP_cat_icon_book-cover-design.svg": [
		92314,
		2314
	],
	"./PAP_cat_icon_brochure-or-menu-design.svg": [
		30423,
		423
	],
	"./PAP_cat_icon_business-card-design.svg": [
		7974,
		7974
	],
	"./PAP_cat_icon_business-tagline.svg": [
		14397,
		4397
	],
	"./PAP_cat_icon_design-consultation.svg": [
		11646
	],
	"./PAP_cat_icon_email-design.svg": [
		80089,
		89
	],
	"./PAP_cat_icon_icon-button-and-widget-design.svg": [
		77890,
		7890
	],
	"./PAP_cat_icon_illustration-and-graphic-design.svg": [
		13314,
		3314
	],
	"./PAP_cat_icon_infographics-design.svg": [
		85696,
		5696
	],
	"./PAP_cat_icon_landing-page-design.svg": [
		90492,
		492
	],
	"./PAP_cat_icon_letterhead-and-stationery-design.svg": [
		91826,
		1826
	],
	"./PAP_cat_icon_logo-and-business-card-design.svg": [
		77716,
		7716
	],
	"./PAP_cat_icon_logo-and-social-media-assets-design.svg": [
		88211,
		8211
	],
	"./PAP_cat_icon_logo-design.svg": [
		93026,
		3026
	],
	"./PAP_cat_icon_magazine-cover-design.svg": [
		24301,
		4301
	],
	"./PAP_cat_icon_merchandise-design.svg": [
		26786,
		6786
	],
	"./PAP_cat_icon_mobile-ui-design.svg": [
		69286,
		9286
	],
	"./PAP_cat_icon_naming-a-business-or-product.svg": [
		96589,
		6589
	],
	"./PAP_cat_icon_other-clothing-design.svg": [
		75192,
		5192
	],
	"./PAP_cat_icon_outdoor-or-signage-design.svg": [
		52486,
		2486
	],
	"./PAP_cat_icon_package-graphics.svg": [
		97472,
		7472
	],
	"./PAP_cat_icon_packaging-design.svg": [
		8010,
		8010
	],
	"./PAP_cat_icon_postcard-or-flyer-design.svg": [
		32512,
		2512
	],
	"./PAP_cat_icon_poster-design.svg": [
		77380,
		7380
	],
	"./PAP_cat_icon_presentation-design.svg": [
		70353,
		353
	],
	"./PAP_cat_icon_product-design.svg": [
		61278,
		1278
	],
	"./PAP_cat_icon_social-media-assets-design.svg": [
		89921,
		9921
	],
	"./PAP_cat_icon_t-shirt-design.svg": [
		48332,
		8332
	],
	"./PAP_cat_icon_tattoo-design.svg": [
		22424,
		2424
	],
	"./PAP_cat_icon_vehicle-wrap-design.svg": [
		51438,
		1438
	],
	"./PAP_cat_icon_wall-mural-art-design.svg": [
		82941,
		2941
	],
	"./PAP_cat_icon_web-banner-design.svg": [
		73146,
		3146
	],
	"./PAP_cat_icon_website-design.svg": [
		74928,
		4928
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65948;
module.exports = webpackAsyncContext;